import Vue from "vue";

// Detects if the app runs as an installed PWA (any windowed display mode).
const isPwa = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.matchMedia("(display-mode: fullscreen)").matches ||
  window.matchMedia("(display-mode: minimal-ui)").matches ||
  window.navigator.standalone === true;

// v-smart-target: keeps in-PWA navigation inside the app window (_self),
// while still opening a new tab on the regular desktop web (_blank).
const apply = (el) => {
  el.setAttribute("target", isPwa() ? "_self" : "_blank");
};

Vue.directive("smart-target", {
  bind: apply,
  // Re-evaluate on patch: display-mode can change at runtime (install/uninstall).
  componentUpdated: apply,
});
